<template>
	<div class="item" :key="cart.id">
		<product v-bind="{item}" :variantsOpen.sync="variantsOpen"/>

		<div class="variants">
			<variant v-for="variant in variants" :key="variant.id" v-bind="variant" v-if="variantsOpen"/>
		</div>
	</div>
</template>

<script>
import product from "./product.vue";
import variant from "./variant.vue";

export default {
	components: {product, variant},
	props: {
		item: {type: Object, required: true},
	},
	data() {
		return {
			variantsOpen: false
		}
	},
	computed: {
		cart: (t) => t.$store.getters["cart/data"],
		variants: (t) => t.item.variants
	}
};
</script>

<style  lang="scss" scoped>
.item {
	margin-bottom: 1px;
}
</style>
